import { render, staticRenderFns } from "./ModelBox.vue?vue&type=template&id=2a58728e&scoped=true&"
import script from "./ModelBox.vue?vue&type=script&lang=js&"
export * from "./ModelBox.vue?vue&type=script&lang=js&"
import style0 from "./ModelBox.vue?vue&type=style&index=0&id=2a58728e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a58728e",
  null
  
)

export default component.exports